module.exports = __webpack_public_path__ + "img/e4_img4.77b9177.jpg";